import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  FlexRowCenter,
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP, TextSpan } from '../../Defaults/Text';
import { formatPrice } from '../../../utilities';

interface Props {
  price: number | string;
  priceWithoutVat?: number | string;
  currency: string;
  oldPrice?: number;
}

function PriceInfo({ price, priceWithoutVat, oldPrice, currency }: Props) {
  return (
    <PricesWrapper>
      <Wrapper>
        <Price>
          {oldPrice && oldPrice > 0 ? (
            <SalePercentage>
              -{Math.round((1 - +price / oldPrice) * 100)} %
            </SalePercentage>
          ) : null}
          {+price > 0
            ? formatPrice(Number(price), 'EUR')
            : __('Cena na vyžiadanie')}{' '}
          {oldPrice && oldPrice > 0 ? (
            <OldPrice>{`${oldPrice} ${currency}`}</OldPrice>
          ) : null}
        </Price>
        {+price > 0 && (
          <SecondaryText>
            {formatPrice(Number(priceWithoutVat), 'EUR')} {__('bez DPH')}
          </SecondaryText>
        )}
      </Wrapper>
    </PricesWrapper>
  );
}

const PricesWrapper = styled(FlexRowCenterVertical)`
  width: 100%;
`;

const Wrapper = styled(FlexCol)`
  justify-content: space-between;
`;

const SalePercentage = styled.div`
  background-color: #fa352f;
  border-radius: ${rem(4)};
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  padding: ${rem(7)} ${rem(9)};
  line-height: ${rem(14)};
  margin-right: ${rem(8)};
`;

const Price = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(24)};
  line-height: ${rem(28)};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: ${rem(4)};
  white-space: nowrap;
  display: flex;
`;

const OldPrice = styled(TextSpan)`
  text-decoration: line-through;
  color: ${({ theme }) => theme.colors.gray};
  font-size: ${rem(14)};
  font-weight: initial;
`;

const SecondaryText = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  color: ${({ theme }) => theme.colors.black};
`;

export { PriceInfo };
